export enum InfantSeating {
  IN_SEAT = "seat",
  ON_LAP = "lap"
}
